import { render, staticRenderFns } from "./LeadDataCheckItem.vue?vue&type=template&id=dbfe0594&scoped=true&"
import script from "./LeadDataCheckItem.vue?vue&type=script&lang=js&"
export * from "./LeadDataCheckItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=dbfe0594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfe0594",
  null
  
)

export default component.exports